const NotFound = () => (
    <div  style={{ minHeight: window.innerHeight - 150, paddingLeft:100 }}>
      <h1>The requested resource could not be found.</h1>
    </div>
  );
  
  export default NotFound;